/**
 * Use this file for any public-facing functionality of your block.
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../build/view.js` and enqueued in the frontend
 * of your site.
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize all loan calculators on the page
    const calculators = document.querySelectorAll('.loan-calculator');
    calculators.forEach(initializeLoanCalculator);
});

function initializeLoanCalculator(calculator) {
    const form = calculator.querySelector('.loan-calculator-form');
    const totalAmountInput = calculator.querySelector('#total-amount');
    const downPaymentInput = calculator.querySelector('#down-payment');
    const interestRateInput = calculator.querySelector('#interest-rate');
    const amortizationPeriodInput = calculator.querySelector('#amortization-period');
    const monthlyPaymentAmount = calculator.querySelector('.monthly-payment .amount');
    const totalInterestAmount = calculator.querySelector('.total-interest .amount');

        // Get show interest setting from data attribute
    const showInterest = calculator.dataset.showInterest === 'true';

    // Simple function to parse numbers that may contain commas
    function parseNumberFromString(str) {
        // Remove commas and parse as float
        return parseFloat(str.replace(/,/g, '')) || 0;
    }

                // Calculate on input change
    const inputs = [totalAmountInput, downPaymentInput, interestRateInput, amortizationPeriodInput];

    inputs.forEach(input => {
        if (input) {
            input.addEventListener('input', function(e) {
                const inputId = e.target.id;
                let value = e.target.value;
                let sanitized = value;

                // Different validation for different input types
                if (inputId === 'total-amount' || inputId === 'down-payment') {
                    // Dollar inputs: allow numbers and commas
                    sanitized = value.replace(/[^0-9,]/g, '');
                } else if (inputId === 'interest-rate') {
                    // Interest rate: allow numbers and decimal point
                    sanitized = value.replace(/[^0-9.]/g, '');
                    // Ensure only one decimal point
                    const parts = sanitized.split('.');
                    if (parts.length > 2) {
                        sanitized = parts[0] + '.' + parts.slice(1).join('');
                    }
                } else if (inputId === 'amortization-period') {
                    // Amortization period: allow only whole numbers
                    sanitized = value.replace(/[^0-9]/g, '');
                }

                if (value !== sanitized) {
                    e.target.value = sanitized;
                }

                calculateLoan();
            });

            input.addEventListener('change', calculateLoan);

            // Add floating label functionality
            setupFloatingLabel(input);
        }
    });

    // Initial calculation and label setup
    calculateLoan();

    // Initial label state check for all inputs
    inputs.forEach(input => {
        if (input) {
            updateLabelState(input);
        }
    });

    function calculateLoan() {
        if (!totalAmountInput || !downPaymentInput || !interestRateInput || !amortizationPeriodInput) {
            return;
        }

        const totalAmount = parseNumberFromString(totalAmountInput.value);
        const downPayment = parseNumberFromString(downPaymentInput.value);
        const interestRate = parseFloat(interestRateInput.value) || 0;
        const amortizationPeriod = parseInt(amortizationPeriodInput.value) || 0;

        // Calculate loan amount (total amount minus down payment)
        const loanAmount = totalAmount - downPayment;

        if (loanAmount <= 0 || interestRate <= 0 || amortizationPeriod <= 0) {
            updateResults(0, 0);
            return;
        }

        // Convert annual interest rate to monthly decimal rate
        const monthlyRate = (interestRate / 100) / 12;

        // Calculate monthly payment using the standard loan payment formula
        // M = P * [r(1 + r)^n] / [(1 + r)^n - 1]
        const monthlyPayment = loanAmount *
            (monthlyRate * Math.pow(1 + monthlyRate, amortizationPeriod)) /
            (Math.pow(1 + monthlyRate, amortizationPeriod) - 1);

        // Calculate total interest
        const totalInterest = (monthlyPayment * amortizationPeriod) - loanAmount;

        updateResults(monthlyPayment, totalInterest);
    }

    function updateResults(monthlyPayment, totalInterest) {
        // Format currency
        const formatCurrency = (amount) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        };

        // Update monthly payment display
        if (monthlyPaymentAmount) {
            monthlyPaymentAmount.textContent = formatCurrency(monthlyPayment);
        }

        // Update total interest display if it should be shown
        if (showInterest && totalInterestAmount) {
            totalInterestAmount.textContent = formatCurrency(totalInterest);
        }
    }

    // Prevent form submission
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
        });
    }

    // Floating label functionality
    function setupFloatingLabel(input) {
        const field = input.closest('.loan-calculator-field');

        if (!field) return;

        // Handle focus events
        input.addEventListener('focus', function() {
            field.classList.add('is-focused');
            updateLabelState(input);
        });

        // Handle blur events
        input.addEventListener('blur', function() {
            field.classList.remove('is-focused');
            updateLabelState(input);
        });

        // Handle input events to check for value
        input.addEventListener('input', function() {
            updateLabelState(input);
        });

        // Handle change events
        input.addEventListener('change', function() {
            updateLabelState(input);
        });
    }

    function updateLabelState(input) {
        const field = input.closest('.loan-calculator-field');

        if (!field) return;

        // Check if input has a value (including values with commas)
        const value = input.value.trim();
        const numericValue = parseNumberFromString(value);
        const hasValue = value !== '' && numericValue > 0;

        if (hasValue) {
            field.classList.add('has-value');
        } else {
            field.classList.remove('has-value');
        }
    }
}
